import { types } from 'mobx-state-tree';

const OrderTracking = types.model('OrderTracking', {
  carrier: types.maybeNull(types.string),
  code: types.maybeNull(types.string),
  url: types.maybeNull(types.string),
});

export default OrderTracking;
